import InvoiceDisplay from './InvoiceDisplay';

export default InvoiceDisplay;
